import Button from "@/components/buttons";
import Link from "next/link";
import TextComponent from "./TextComponent";
import { useZStore } from "@/utils/z-store";
import { useEffect } from "react";
import { trackGAEvent } from "@/utils/ga";

interface ConfirmationContentProps {
  email: string;
  plan: string;
  totalPaid?: number;
  discounts?: any[];
}

// Renamed from ConfirmationPage to ConfirmationContent
export function ConfirmationContent({
  email,
  plan,
  totalPaid,
  discounts,
}: ConfirmationContentProps) {
  const { actions } = useZStore();

  useEffect(() => {
    let planKey = "basic";
    const lowerPlan = plan.toLowerCase();
    if (lowerPlan.includes("premium")) {
      planKey = "premium";
    } else if (lowerPlan.includes("standard")) {
      planKey = "standard";
    }
    trackGAEvent(`thankyou_${planKey}`, {});
    // Canonical funnel event (Tracking tab): payment succeeded.
    trackGAEvent("payment_completed", { plan: planKey });
  }, [plan]);

  return (
    <div className="font-['Poppins']">
      <TextComponent
        type="h2"
        className="text-2xl font-semibold text-indigo-950"
      >
        Thank you for your order
      </TextComponent>
      <div className="mt-8 space-y-6 text-base text-slate-600">
        <TextComponent type="body">
          You are all set up to access the Engine! An email confirmation has
          been sent to{" "}
          <span className="font-medium text-blue-500">{email}</span>.
        </TextComponent>
        <TextComponent type="body">
          You now have access to a powerful dashboard designed to optimize your
          email marketing efforts and help you arrange your metrics effortlessly
          for immediate insights. Start exploring your customizable metrics,
          save your favorite layouts, and create comprehensive PDF reports with
          ease. If you have any questions or need assistance, our support team
          is here to help.
        </TextComponent>
        {totalPaid && (
          <TextComponent type="body" className="mt-4">
            <span className="font-medium">Total Paid: </span>$
            {totalPaid.toFixed(2)}
            {discounts && discounts.length > 0 && (
              <span className="ml-2 text-green-600">
                (Discount Applied:{" "}
                {discounts
                  .map((d) => d.coupon?.name || d.coupon?.id)
                  .join(", ")}
                )
              </span>
            )}
          </TextComponent>
        )}
        <TextComponent type="body">Start your engine!</TextComponent>
      </div>
      <div className="mt-12">
        <Link href="/dashboard/home">
          <Button
            id={`thankyou_${plan.toLowerCase()}`}
            className="h-10 w-[253px]"
            onClick={() => actions.closeModal()}
          >
            <TextComponent type="button">Dashboard</TextComponent>
          </Button>
        </Link>
      </div>
    </div>
  );
}

export const ConfirmationPage = ConfirmationContent;
